import ApplyJobs from "../Pages/Miscellaneous/JobSearch/ApplyJobs";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import DetailedCourse from "../Pages/Miscellaneous/Learning/DetailedCourse";
import Alert from "../Pages/UiKits/Alert";
import Avatars from "../Pages/UiKits/Avatars";
import Typography from "../Pages/UiKits/Typography";
import GoogleMaps from "../Pages/Miscellaneous/Maps/GoogleMaps";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle";
import Faq from "../Pages/Miscellaneous/FAQ";
import ImageHoverEffects from "../Pages/Miscellaneous/Gallery/ImageHoverEffects";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import MasonryGalleryDescription from "../Pages/Miscellaneous/Gallery/MasonryGalleryDescription";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import SamplePage from "../Pages/Pages/SamplePage";
import API from "../Pages/Tables/DataTables/API";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit";
import BasicInit from "../Pages/Tables/DataTables/BasicInit";
import DataSource from "../Pages/Tables/DataTables/DataSource";
import TableComponents from "../Pages/Tables/ReactstrapTables/TableComponents";
import FormWizard2 from "../Pages/Forms/FormLayout/FormWizard2";
import TwoFactor from "../Pages/Forms/FormLayout/TwoFactor";
import BasicTables from "../Pages/Tables/ReactstrapTables/BasicTables";
import FormWizard1 from "../Pages/Forms/FormLayout/FormWizard1";
import Clipboard from "../Pages/Forms/FormWidgets/Clipboard";
import Typeahead from "../Pages/Forms/FormWidgets/Typeahead";
import MegaOptions from "../Pages/Forms/FormControls/MegaOptions";
import DatePicker from "../Pages/Forms/FormWidgets/Datepicker";
import Switch from "../Pages/Forms/FormWidgets/Switch";
import Touchspin from "../Pages/Forms/FormWidgets/Touchspin";
import CheckboxAndRadio from "../Pages/Forms/FormControls/CheckboxAndRadio";
import InputMask from "../Pages/Forms/FormControls/InputMask";
import GoogleChart from "../Pages/Charts/GoogleChart";
import BaseInputs from "../Pages/Forms/FormControls/BaseInputs";
import FormValidation from "../Pages/Forms/FormControls/FormValidation";
import InputGroups from "../Pages/Forms/FormControls/InputGroups";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJsChart from "../Pages/Charts/ChartJsChart";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import FontAwesome from "../Pages/Icons/FontAwesome";
import IconlyIcon from "../Pages/Icons/IconlyIcon";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Timeline from "../Pages/BonusUi/Timeline";
import Buttons from "../Pages/Buttons";
import BasicCard from "../Pages/BonusUi/BasicCard";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import Pagination from "../Pages/BonusUi/Pagination";
import Slider from "../Pages/BonusUi/Slider";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import Dropzone from "../Pages/BonusUi/Dropzone";
import Rating from "../Pages/BonusUi/Rating";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Tour from "../Pages/BonusUi/Tour";
import Scrollable from "../Pages/BonusUi/Scrollable";
import Toasts from "../Pages/BonusUi/Toasts";
import TreeView from "../Pages/BonusUi/TreeView";
import Lists from "../Pages/UiKits/Lists";
import Dropdown from "../Pages/UiKits/Dropdown";
import Modal from "../Pages/UiKits/Modal";
import Tabs from "../Pages/UiKits/TabBootstrap";
import Accordion from "../Pages/UiKits/Accordion";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import Progress from "../Pages/UiKits/Progress";
import Tooltip from "../Pages/UiKits/Tooltip";
import Grid from "../Pages/UiKits/Grid";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Popover from "../Pages/UiKits/Popover";
import Invoice6 from "../Pages/Applications/ECommerce/Invoices/Invoice6";
import Invoice5 from "../Pages/Applications/ECommerce/Invoices/Invoice5";
import Pricing from "../Pages/Applications/ECommerce/Pricing";
import Invoice1 from "../Pages/Applications/ECommerce/Invoices/Invoice1";
import Invoice2 from "../Pages/Applications/ECommerce/Invoices/Invoice2";
import Invoice3 from "../Pages/Applications/ECommerce/Invoices/Invoice3";
import Invoice4 from "../Pages/Applications/ECommerce/Invoices/Invoice4";
import CategoryPage from "../Pages/Applications/ECommerce/CategoryPage";
import ProductList from "../Pages/Applications/ECommerce/ProductList";
import PaymentDetails from "../Pages/Applications/ECommerce/PaymentDetails";
import OrderHistory from "../Pages/Applications/ECommerce/OrderHistory";
import Cart from "../Pages/Applications/ECommerce/Cart";
import Wishlist from "../Pages/Applications/ECommerce/Wishlist";
import Checkout from "../Pages/Applications/ECommerce/Checkout";
import AddProduct from "../Pages/Applications/ECommerce/AddProduct";
import Product from "../Pages/Applications/ECommerce/Product";
import ToDo from "../Pages/Applications/ToDo";
import SearchResult from "../Pages/Applications/SearchResult";
import ProductPage from "../Pages/Applications/ECommerce/ProductPage";
import Calendar from "../Pages/Applications/Calendar";
import SocialApp from "../Pages/Applications/SocialApp";
import Contacts from "../Pages/Applications/Contacts";
import Tasks from "../Pages/Applications/Tasks";
import LetterBox from "../Pages/Applications/LetterBox";
import PrivateChat from "../Pages/Applications/Chat/PrivateChat";
import GroupChat from "../Pages/Applications/Chat/GroupChat";
import EditProfile from "../Pages/Applications/Users/UsersEdit";
import ProjectCreate from "../Pages/Applications/Project/ProjectCreate";
import FileManager from "../Pages/Applications/FileManager";
import General from "../Pages/Widgets/General";
import Chart from "../Pages/Widgets/Chart";
import ProjectList from "../Pages/Applications/Project/ProjectList";
import Default from "../Pages/Dashboard/Default";
import Ecommerce from "../Pages/Dashboard/Ecommerce";
import LeafletMaps from "../Pages/Miscellaneous/Maps/LeafletMaps";
import AceCodeEditor from "../Pages/Miscellaneous/Editor/AceCodeEditor";
import QuillEditor from "../Pages/Miscellaneous/Editor/QuillEditor";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import UserCards from "../Pages/Applications/Users/UserCards";
import UserProfile from "../Pages/Applications/Users/UserProfile";
import Bookmarks from "../Pages/Applications/Bookmarks";
import Education from "../Pages/Dashboard/Education";

import AddBrands from "../Pages/Brands/AddBrands";
import ViewBrands from "../Pages/Brands/ViewBrands";
import EditBrands from "../Pages/Brands/EditBrands";
import AddVehicleModel from "../Pages/VehicleModel/AddVehicleModel";
import ViewVehicleModel from "../Pages/VehicleModel/ViewVehicleModel";
import EditVehicleModel from "../Pages/VehicleModel/EditVehicleModel";
import AddLanguage from "../Pages/Language/AddLanguage";
import ViewLanguage from "../Pages/Language/ViewLanguage";
import EditLanguage from "../Pages/Language/EditLanguage";
import AddAgent from "../Pages/Agent/AddAgent";
import ViewAgent from "../Pages/Agent/ViewAgent";
import EditAgent from "../Pages/Agent/EditAgent";
import AddGeneralSetting from "../Pages/GeneralSetting/AddGeneralSetting";
import ViewGeneralSetting from "../Pages/GeneralSetting/ViewGeneralSetting";
import EditGeneralSetting from "../Pages/GeneralSetting/EditGeneralSetting";
import CallHistory from "../Pages/Agent/CallHistory";
import ViewCustomer from "../Pages/Customer/ViewCustomer";
import AddPackage from "../Pages/Package/AddPackage";
import ViewPackage from "../Pages/Package/ViewPackage";
import EditPackage from "../Pages/Package/EditPackage";
import AddPackagePaymentSetting from "../Pages/PackagePaymentSetting/AddPackagePaymentSetting";
import ViewPackagePaymentSetting from "../Pages/PackagePaymentSetting/ViewPackagePaymentSetting";
import EditPackagePaymentSetting from "../Pages/PackagePaymentSetting/EditPackagePaymentSetting";
import Alluser from "../Pages/Alluser";
import PackageBought from "../Pages/Customer/PackageBought";
import CallReport from "../Pages/Report/CallReport";
import ViewSmsSetting from "../Pages/SmsSetting/ViewSmsSetting";
import EditSmsSetting from "../Pages/SmsSetting/EditSmsSetting";
import AddSmsSetting from "../Pages/SmsSetting/AddSmsSetting";
import AddPaymentSetting from "../Pages/PaymentSetting/AddPaymentSetting";
import ViewPaymentSetting from "../Pages/PaymentSetting/ViewPaymentSetting";
import EditPaymentSetting from "../Pages/PaymentSetting/EditPaymentSetting";
import CustomerReport from "../Pages/Report/CustomerReport";
import AgentReport from "../Pages/Report/AgentReport";
import CashFlowReport from "../Pages/Report/CashFlowReport";
import ViewExpense from "../Pages/Expense/ViewExpense";
import EditExpense from "../Pages/Expense/EditExpense";
import ProfitReport from "../Pages/Report/ProfitReport";
import WithdrawalSetting from "../Pages/WithdrawalSetting/WithdrawalSetting";
import CallPayout from "../Pages/Report/CallPayout";
import AgentSupport from "../Pages/Support/AgentSupport";
import CustomerSupport from "../Pages/Support/CustomerSupport";
import AddVideoPackagePaymentSetting from "../Pages/VideoPackagePaymentSetting/AddVideoPackagePaymentSetting";
import ViewVideoPackagePaymentSetting from "../Pages/VideoPackagePaymentSetting/ViewVideoPackagePaymentSetting";
import EditVideoPackagePaymentSetting from "../Pages/VideoPackagePaymentSetting/EditVideoPackagePaymentSetting";
import AddVideoPackage from "../Pages/VideoPackage/AddVideoPackage";
import ViewVideoPackage from "../Pages/VideoPackage/ViewVideoPackage";
import EditVideoPackage from "../Pages/VideoPackage/EditVideoPackage";
import VideoCallHistory from "../Pages/Agent/VideoCallHistory";
import VideoCallReport from "../Components/Report/VideoCallReport";

export const routes = [
  { path: `/dashboard`, element: <Default /> },

  //brands
  { path: `/add_brands`, element: <AddBrands /> },
  { path: `/view_brands`, element: <ViewBrands /> },
  { path: `/edit_brands`, element: <EditBrands /> },

  //model
  { path: `/add_model`, element: <AddVehicleModel /> },
  { path: `/view_model`, element: <ViewVehicleModel /> },
  { path: `/edit_model`, element: <EditVehicleModel /> },

  //language
  { path: `/add_language`, element: <AddLanguage /> },
  { path: `/view_language`, element: <ViewLanguage /> },
  { path: `/edit_language`, element: <EditLanguage /> },

  //agent
  { path: `/add_agent`, element: <AddAgent /> },
  { path: `/view_agent`, element: <ViewAgent /> },
  { path: `/edit_agent`, element: <EditAgent /> },
  { path: `/call_history`, element: <CallHistory /> },
  { path: `/video_call_history`, element: <VideoCallHistory /> },

  //generalSetting
  { path: `/add_general_setting`, element: <AddGeneralSetting /> },
  { path: `/view_general_setting`, element: <ViewGeneralSetting /> },
  { path: `/edit_general_setting`, element: <EditGeneralSetting /> },

  //customer
  { path: `/view_customer`, element: <ViewCustomer /> },
  { path: `/package_bought`, element: <PackageBought /> },

  //package
  { path: `/add_package`, element: <AddPackage /> },
  { path: `/view_package`, element: <ViewPackage /> },
  { path: `/edit_package`, element: <EditPackage /> },

  //packagePaymentSetting
  {
    path: `/add_package_payment_setting`,
    element: <AddPackagePaymentSetting />,
  },
  {
    path: `/view_package_payment_setting`,
    element: <ViewPackagePaymentSetting />,
  },
  {
    path: `/edit_package_payment_setting`,
    element: <EditPackagePaymentSetting />,
  },

  //videopackagePaymentSetting
  {
    path: `/add_video_package_payment_setting`,
    element: <AddVideoPackagePaymentSetting />,
  },
  {
    path: `/view_video_package_payment_setting`,
    element: <ViewVideoPackagePaymentSetting />,
  },
  {
    path: `/edit_video_package_payment_setting`,
    element: <EditVideoPackagePaymentSetting />,
  },

  //video package
  { path: `/add_video_package`, element: <AddVideoPackage /> },
  { path: `/view_video_package`, element: <ViewVideoPackage /> },
  { path: `/edit_video_package`, element: <EditVideoPackage /> },

  //all user
  { path: `/alluser`, element: <Alluser /> },

  //report
  { path: `/call_report`, element: <CallReport /> },
  { path: `/video_call_report`, element: <VideoCallReport /> },
  { path: `/customer_report`, element: <CustomerReport /> },
  { path: `/agent_report`, element: <AgentReport /> },
  { path: `/cash_flow_report`, element: <CashFlowReport /> },
  { path: `/profit_report`, element: <ProfitReport /> },
  { path: `/payout_report`, element: <CallPayout /> },

  //smsSetting
  { path: `/add_sms_setting`, element: <AddSmsSetting /> },
  { path: `/view_sms_setting`, element: <ViewSmsSetting /> },
  { path: `/edit_sms_setting`, element: <EditSmsSetting /> },

  //paymentSetting
  { path: `/add_payment_setting`, element: <AddPaymentSetting /> },
  { path: `/view_payment_setting`, element: <ViewPaymentSetting /> },
  { path: `/edit_payment_setting`, element: <EditPaymentSetting /> },

  //expense
  { path: `/view_expense`, element: <ViewExpense /> },
  { path: `/edit_expense`, element: <EditExpense /> },

  //withdrawal setting

  { path: `/withdrawal_setting`, element: <WithdrawalSetting /> },

  //support
  { path: `/agent_support`, element: <AgentSupport /> },
  { path: `/customer_support`, element: <CustomerSupport /> },

  {
    path: `${process.env.PUBLIC_URL}/ui_kits/typography`,
    element: <Typography />,
  },
  { path: `${process.env.PUBLIC_URL}/ui_kits/tabs`, element: <Tabs /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/modal`, element: <Modal /> },
  {
    path: `${process.env.PUBLIC_URL}/ui_kits/helperclass`,
    element: <HelperClasses />,
  },
  { path: `${process.env.PUBLIC_URL}/ui_kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/popover`, element: <Popover /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/avatars`, element: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/alert`, element: <Alert /> },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/add_product`,
    element: <AddProduct />,
  },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product`, element: <Product /> },
  { path: `${process.env.PUBLIC_URL}/app/todo`, element: <ToDo /> },
  {
    path: `${process.env.PUBLIC_URL}/app/search_result`,
    element: <SearchResult />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/product_page`,
    element: <ProductPage />,
  },
  { path: `${process.env.PUBLIC_URL}/app/calendar`, element: <Calendar /> },
  { path: `${process.env.PUBLIC_URL}/app/social_app`, element: <SocialApp /> },
  { path: `${process.env.PUBLIC_URL}/app/contacts`, element: <Contacts /> },
  { path: `${process.env.PUBLIC_URL}/app/task`, element: <Tasks /> },
  {
    path: `${process.env.PUBLIC_URL}/email/letter_box`,
    element: <LetterBox />,
  },
  {
    path: `${process.env.PUBLIC_URL}/chat/private_chat`,
    element: <PrivateChat />,
  },
  { path: `${process.env.PUBLIC_URL}/chat/group_chat`, element: <GroupChat /> },
  {
    path: `${process.env.PUBLIC_URL}/users/user_edit`,
    element: <EditProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/users/user_profile`,
    element: <UserProfile />,
  },
  { path: `${process.env.PUBLIC_URL}/users/cards`, element: <UserCards /> },
  {
    path: `${process.env.PUBLIC_URL}/project/create_new`,
    element: <ProjectCreate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/file_manager`,
    element: <FileManager />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/education`,
    element: <Education />,
  },
  { path: `${process.env.PUBLIC_URL}/widgets/general`, element: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, element: <Chart /> },
  {
    path: `${process.env.PUBLIC_URL}/project/project_list`,
    element: <ProjectList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    element: <Ecommerce />,
  },
  { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/avatars`, element: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/alert`, element: <Alert /> },
  {
    path: `${process.env.PUBLIC_URL}/job_search/card_view`,
    element: <CardsView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/job_search/list_view`,
    element: <ListView />,
  },
  {
    path: `${process.env.PUBLIC_URL}/job_search/job_detail`,
    element: <JobDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/job_search/apply`,
    element: <ApplyJobs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/learning/learning_list`,
    element: <LearningList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/learning/learning_course`,
    element: <DetailedCourse />,
  },
  { path: `${process.env.PUBLIC_URL}/map/google_map`, element: <GoogleMaps /> },
  {
    path: `${process.env.PUBLIC_URL}/gallery/masonry_gallery`,
    element: <MasonryGallery />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/masonry_with_desc`,
    element: <MasonryGalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/hover_effect`,
    element: <ImageHoverEffects />,
  },
  {
    path: `${process.env.PUBLIC_URL}/blog/blog_details`,
    element: <BlogDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/blog/blog_single`,
    element: <BlogSingle />,
  },
  { path: `${process.env.PUBLIC_URL}/blog/add_post`, element: <AddPost /> },
  { path: `${process.env.PUBLIC_URL}/faq/faq`, element: <Faq /> },
  {
    path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`,
    element: <Knowledgebase />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/gallery_grids`,
    element: <GalleryGrid />,
  },
  {
    path: `${process.env.PUBLIC_URL}/gallery/gallery_grid_desc`,
    element: <GalleryDescription />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_table/table_component`,
    element: <TableComponents />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_table/basic_init`,
    element: <BasicInit />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/data_table/advance_init`,
    element: <AdvanceInit />,
  },
  { path: `${process.env.PUBLIC_URL}/table/data_table/api`, element: <API /> },
  {
    path: `${process.env.PUBLIC_URL}/table/data_table/data_sources`,
    element: <DataSource />,
  },
  {
    path: `${process.env.PUBLIC_URL}/pages/sample_page`,
    element: <SamplePage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_2`,
    element: <FormWizard2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_layout/two_factor`,
    element: <TwoFactor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`,
    element: <BasicTables />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_widget/typeahead`,
    element: <Typeahead />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_widget/clipboard`,
    element: <Clipboard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_1`,
    element: <FormWizard1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/mega_option`,
    element: <MegaOptions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_widget/datepicker`,
    element: <DatePicker />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_widget/touchspin`,
    element: <Touchspin />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_widget/switch`,
    element: <Switch />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/radio_checkbox`,
    element: <CheckboxAndRadio />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_mask`,
    element: <InputMask />,
  },
  {
    path: `${process.env.PUBLIC_URL}/charts/google_chart`,
    element: <GoogleChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/base_input`,
    element: <BaseInputs />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`,
    element: <FormValidation />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_groups`,
    element: <InputGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/fontawesome_icon`,
    element: <FontAwesome />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/feather_icon`,
    element: <FeatherIcons />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/iconly_icon`,
    element: <IconlyIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/icons/themify_icon`,
    element: <ThemifyIcon />,
  },
  {
    path: `${process.env.PUBLIC_URL}/charts/apex_chart`,
    element: <ApexChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/charts/chartjs_chart`,
    element: <ChartJsChart />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/creative_cards`,
    element: <CreativeCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/timeline`,
    element: <Timeline />,
  },
  { path: `${process.env.PUBLIC_URL}/buttons`, element: <Buttons /> },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/breadcrumb`,
    element: <Breadcrumb />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/range_slider`,
    element: <RangeSlider />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/image_cropper`,
    element: <ImageCropper />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/basic_cards`,
    element: <BasicCard />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/sweet_alert2`,
    element: <SweetAlert />,
  },
  { path: `${process.env.PUBLIC_URL}/bonus_ui/slider`, element: <Slider /> },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/pagination`,
    element: <Pagination />,
  },
  { path: `${process.env.PUBLIC_URL}/bonus_ui/rating`, element: <Rating /> },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/dropzone`,
    element: <Dropzone />,
  },
  { path: `${process.env.PUBLIC_URL}/bonus_ui/tour`, element: <Tour /> },
  { path: `${process.env.PUBLIC_URL}/bonus_ui/ribbons`, element: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/list`, element: <Lists /> },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/scrollable`,
    element: <Scrollable />,
  },
  {
    path: `${process.env.PUBLIC_URL}/bonus_ui/tree_view`,
    element: <TreeView />,
  },
  { path: `${process.env.PUBLIC_URL}/bonus_ui/toasts`, element: <Toasts /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/tabs`, element: <Tabs /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/modal`, element: <Modal /> },
  {
    path: `${process.env.PUBLIC_URL}/ui_kits/helperclass`,
    element: <HelperClasses />,
  },
  { path: `${process.env.PUBLIC_URL}/ui_kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/popover`, element: <Popover /> },
  {
    path: `${process.env.PUBLIC_URL}/ui_kits/accordion`,
    element: <Accordion />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ui_kits/tagpills`,
    element: <TagAndPills />,
  },
  { path: `${process.env.PUBLIC_URL}/ui_kits/progress`, element: <Progress /> },
  { path: `${process.env.PUBLIC_URL}/ui_kits/tooltip`, element: <Tooltip /> },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice5`,
    element: <Invoice5 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice6`,
    element: <Invoice6 />,
  },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, element: <Pricing /> },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice1`,
    element: <Invoice1 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice2`,
    element: <Invoice2 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice3`,
    element: <Invoice3 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice4`,
    element: <Invoice4 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/category_page`,
    element: <CategoryPage />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/product_list`,
    element: <ProductList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/payment_details`,
    element: <PaymentDetails />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/order_history`,
    element: <OrderHistory />,
  },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, element: <Cart /> },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`,
    element: <Wishlist />,
  },
  {
    path: `${process.env.PUBLIC_URL}/ecommerce/checkout`,
    element: <Checkout />,
  },
  {
    path: `${process.env.PUBLIC_URL}/map/leaflet_map`,
    element: <LeafletMaps />,
  },
  {
    path: `${process.env.PUBLIC_URL}/editor/quill_editor`,
    element: <QuillEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/editor/ace_editor`,
    element: <AceCodeEditor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/support_ticket/support_ticket`,
    element: <SupportTicket />,
  },
  { path: `${process.env.PUBLIC_URL}/app/bookmark`, element: <Bookmarks /> },
];
